import PropTypes from 'prop-types';
import React from 'react';

import * as D from '../../../deps';
import BackstageHeaderPlayPauseButton from '../../BackstageHeaderPlayPauseButton';
import BackstageLargeHeader from '../../BackstageLargeHeader';
import ListenerCountSubtitleLarge from '../../common/ListenerCountSubtitleLarge';

const ArtistLargeHeader = props => {
  const {
    name,
    largeHeaderDominantColor,
    largeHeaderUrl,
    stationListenerCount,
    topSongsIsDisabled,
    topSongsLooksDisabled,
    isArtistTopSongsPlaying,
    playTopSongs,
    pauseTopSongs,
  } = props;

  const LargeHeaderButton = (
    <BackstageHeaderPlayPauseButton
      theme={D.ButtonT3Theme.OPAQUE_WHITE}
      isPillShaped={true}
      isDisabled={topSongsIsDisabled}
      looksDisabled={topSongsLooksDisabled}
      iconType={isArtistTopSongsPlaying ? 'pause' : 'play'}
      onClick={isArtistTopSongsPlaying ? pauseTopSongs : playTopSongs}
    />
  );

  return (
    <BackstageLargeHeader
      listenerCount={<ListenerCountSubtitleLarge stationListenerCount={stationListenerCount} />}
      name={name}
      dominantColor={largeHeaderDominantColor}
      useLightTheme={!D.Utils.Art.isColorDark(largeHeaderDominantColor)}
      largeHeaderImageUrl={largeHeaderUrl}
      playPauseButton={LargeHeaderButton}
      isCuratorExperienceEnabled={true}
    />
  );
};

ArtistLargeHeader.propTypes = {
  name: PropTypes.string,
  largeHeaderDominantColor: PropTypes.string,
  largeHeaderUrl: PropTypes.string,
  stationListenerCount: PropTypes.number,
  topSongsIsDisabled: PropTypes.bool,
  topSongsLooksDisabled: PropTypes.bool,
  isArtistTopSongsPlaying: PropTypes.bool,
  playTopSongs: PropTypes.bool,
  pauseTopSongs: PropTypes.bool,
};

export default ArtistLargeHeader;
